import { Heading, HStack, type StackProps } from "@chakra-ui/react";
import type React from "react";
import type { FunctionComponent } from "react";

type CardHeaderProps = {
  title: React.ReactNode;
  mb?: StackProps["mb"];
};

export const CardHeader: FunctionComponent<
  React.PropsWithChildren<CardHeaderProps>
> = ({ title, children, mb = "4" }) => (
  <HStack alignItems="baseline" justify="space-between" mb={mb}>
    <Heading fontSize="xl">{title}</Heading>

    {children && (
      <HStack fontSize="xs" spacing="1">
        {children}
      </HStack>
    )}
  </HStack>
);
